import React from "react";
import ComponentTitle from "./ComponentTitle";
import AvgRowTable from "./AvgRowTable";
import AVERAGE_COLUMN_LIST_DATA from "./data/averageColumnListData";
import Button from "./Button";
import { Excel } from "../../util/excel";

const Average = ({resbody}) => {
  return (
    <div className="flex-grow">
      <div className="border-gray-400 border-b py-1 flex">
        <ComponentTitle title={"☞ 지종별/평량별/호기별 평균"} />
        ({resbody?.resultData.length || 0} 건)
        {/* <Button 
          buttonAction={() => Excel(resbody.resultData, AVERAGE_COLUMN_LIST_DATA)} 
          buttonText={"엑셀변환"}
          /> */}
      </div>
      <div className="flex flex-col flex-grow p-1">
        <div className="max-w-fit max-h-64 p-1 border-b border-gray-400 flex-col flex flex-grow">
          <AvgRowTable resbody={resbody} columnListData={AVERAGE_COLUMN_LIST_DATA} />
        </div>
      </div>
    </div>
  )
}

export default Average;